import React from 'react';
import { pageTitle } from '../PageTitle';
import HeaderOne from '../Header/HeaderTwo';
import FooterOne from '../Footer/FooterTwo';
import BreadCrumb from '../BreadCrumb';
import { Link } from 'react-router-dom';
import { faBuilding } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const Contact = () => {
    pageTitle('Contact');
    const handleSubmitOne = async (event) => {
        event.preventDefault();
        
        // Get form data
        const formData = new FormData(event.target);
        const formObject = {
            name: formData.get('name'),
            email: formData.get('email'),
            subject: formData.get('subject'),
            phone: formData.get('phone'),
            message: formData.get('message')
        };
        
        // Log the form data
        console.log('Contact Form Submission:', formObject);
        
        try {
            // Send data to API endpoint
            const response = await fetch('https://simsolver.epitomeri.com/api/user/epitomeri_contact_form_submission', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formObject)
            });
            
            if (response.ok) {
                const result = await response.json();
                console.log('Form submitted successfully:', result);
                alert('Message sent successfully!');
                event.target.reset(); // Clear the form
            } else {
                console.error('Form submission failed:', response.statusText);
                alert('Failed to send message. Please try again.');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('An error occurred. Please try again later.');
        }
    };

    return (

        <>
            <HeaderOne></HeaderOne>
            <BreadCrumb></BreadCrumb>
            <section className="contact__page p_relative see__pad">
                <div className="auto-container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-ms-12">
                            <div className="contact__left">
                                {/* <figure>
                                    <img src={contact} alt="" />
                                </figure> */}
                                <h4>Contact Information</h4>
                                <div className="contact__info">
                                    <div className="contact__block">
                                        <div className="icon">
                                            <i className="icon-19"></i>
                                        </div>
                                        <div className="contact__text">
                                            <Link to="tell:7342726655">+1(734) 272-6655</Link> <br />
                                        </div>
                                    </div>
                                    <div className="contact__block">
                                        <div className="icon two">
                                            <i className="icon-20"></i>
                                        </div>
                                        <div className="contact__text">

                                            <Link to="mailto:contact@epitomeri.com">contact@epitomeri.com</Link>
                                        </div>
                                    </div>
                                    <div className="contact__block">
                                        <div className="icon three" >
                                            <i><FontAwesomeIcon icon={faBuilding} size='1x' /></i>
                                        </div>
                                        <div className="contact__text">
                                            <p style={{ lineHeight: "normal", margin: 0 }}>205 Van Buren St, Suite 120<br />Herndon, VA, 20170</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-12">
                            <div className="contact__right">
                                <div className="form__title">
                                    <div className="title__data">
                                        <div className="sub__title">
                                            <h4>Contact Us</h4>
                                        </div>
                                        <div className="title">
                                            {/* <h2>Get a Free Quote</h2> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="form-inner">
                                    <form onSubmit={handleSubmitOne} method="post" action="contact.php" className="default-form">
                                        <div className="row clearfix">
                                            <div className="col-xl-6 form-group">
                                                <input type="name" name="name" placeholder="Your Name *" required="" />
                                            </div>
                                            <div className="col-xl-6 col-lg-12 form-group">
                                                <input type="email" name="email" placeholder="Your Email *" required="" />
                                            </div>
                                            <div className="col-xl-6 col-lg-12 form-group">
                                                <input type="text" name="subject" placeholder="Your Subject " required="" />
                                            </div>
                                            <div className="col-xl-6 col-lg-12 form-group">
                                                <input type="text" name="phone" placeholder="Your Phone " required="" />
                                            </div>
                                            <div className="ccol-xl-6 col-lg-12 form-group">
                                                <textarea name="message" placeholder="Message"></textarea>
                                            </div>
                                            <div className="col-xl-12 form-group message-btn btn-box">
                                                <button className="theme-btn theme-btn-one" type="submit" name="submit-form">Send your Message</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <iframe title='Location' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6205.228294477237!2d-77.39162792354574!3d38.95564244326453!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b647e54d24f0a7%3A0xce12e7b5be9a12b7!2s205%20Van%20Buren%20St%2C%20Herndon%2C%20VA%2020170!5e0!3m2!1sen!2sus!4v1740160113496!5m2!1sen!2sus" width="100%" height="600px" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            <FooterOne></FooterOne>
        </>
    );
};

export default Contact;
